import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import Header from "../components/Header";
import styles from './index.module.css';
import NotFound from "../components/NotFound";
import Footer from "../components/Footers";
import NormalUserRoutes from "../routes/NormalUserRoutes";
import FAQ from "../components/FAQ";

const UserLayout = () => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);
    const closeSidebar = () => setSidebarOpen(false);

    return (
            <div className={styles.main}>                
            <Header toggleSidebar={toggleSidebar}/>
            <div className={styles.content}>
                <Routes>
                    {NormalUserRoutes.map((prop, key) => (
                        <Route path={prop.path} element={prop.element} key={key} />
                    ))}
                    <Route path="*" element={<div><NotFound/></div>} />
                </Routes>  
                <FAQ/>
            </div>   
                <Footer/>       
            </div>
    );
};

export default UserLayout;
